import {WeatherMapTypeFilter} from '@/weather/WeatherModels';
import {HTTP} from '@/services/HttpServices';

const BASE_PATH = '/admin/weather/map-type-filters';

export function listWeatherMapTypeFilters(): Promise<WeatherMapTypeFilter[]> {
  return HTTP.get(`${BASE_PATH}`);
}

export async function updateWeatherMapTypeFilter(filter: WeatherMapTypeFilter): Promise<void> {
  await HTTP.put(`${BASE_PATH}/${filter.id}`, filter);
}

export function createWeatherMapTypeFilter(filter: WeatherMapTypeFilter): Promise<WeatherMapTypeFilter> {
  return HTTP.post(BASE_PATH, filter);
}

export async function deleteWeatherMapTypeFilter(id: number): Promise<void> {
  return HTTP.httpDelete(`${BASE_PATH}/${id}`);
}

export async function reorderWeatherMapTypeFilters(newOrder: { id: number, displayOrder: number }[]): Promise<void> {
  await HTTP.post(`${BASE_PATH}/reorder`, {newOrder});
}
